import React from 'react';
import ReactDOM from 'react-dom';

// Redux Store
import store from './store';
import { Provider } from 'react-redux';

import './index.css';
import './styles/assets/font-style.css';
import { Provider as AuthProvider } from './Redux/context/AuthContext';
// import reportWebVitals from './reportWebVitals';
// import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// reportWebVitals();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
